<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="gax-label">
  {{ label }}<span class="required-asterisk">{{ required ? "*" : "" }}</span>
  @if (showInfoIcon) {
    <gax-help-icon (click)="openInfoModal($event)">help</gax-help-icon>
  }
</div>
<div #container>
  <div class="control" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <div>
      @switch (!!selectTrigger) {
        @default {
          <div class="ga-select-min-line">
            <span class="selected-value" [class.placeholder]="!displayValue">{{
              displayValue || placeholder
            }}</span>
          </div>
        }
        @case (true) {
          <ng-container
            *ngTemplateOutlet="selectTriggerTemplate"
          ></ng-container>
        }
      }
    </div>

    <div class="suffix">
      @if (firstError && touched) {
        <mat-icon color="warn" [@fadeIn]>error </mat-icon>
      }
      @if (!hideCaret) {
        <div class="caret-wrapper">
          <div class="drop-down-caret"></div>
        </div>
      }
      <!-- <mat-spinner *ngIf="loading$ | async" [diameter]="24"></mat-spinner> -->
    </div>
  </div>

  @if (!(firstError && touched)) {
    <div [@fadeIn] class="hint">
      {{ hint }}
    </div>
  }

  @if (firstError && touched) {
    <ng-container [ngTemplateOutlet]="firstError.template"></ng-container>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetY]="0"
  [cdkConnectedOverlayOffsetX]="0"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayPanelClass="ga-select-overlay-panel"
  (backdropClick)="closePanel()"
  (detach)="closePanel()"
  [cdkConnectedOverlayWidth]="
    origin.elementRef.nativeElement.getBoundingClientRect().width
  "
  (positionChange)="onPanelPositionChange($event)"
>
  <div
    class="panel"
    [class.panelAbove]="panelAbove"
    [@dropDown]
    (@dropDown.done)="onPanelAmimationsDone($event)"
  >
    @if (enableSearch()) {
      <div class="search-bar">
        <mat-icon>search</mat-icon>
        <input
          #autocompleteInput
          class="autocompleteInput overlay-on-top"
          (input)="onAutocompleteInputChange($event)"
          [value]="autocompleteSearchTerm"
          type="text"
          placeholder="Search"
        />
      </div>
    }
    <div class="drop-down-options">
      @if (multiple && showAllSelected) {
        <div
          [class.selected]="allSelected"
          (click)="!disableSelectAll && toggleAllSelection()"
          class="select-all-option"
          [class.disabled]="disableSelectAll"
        >
          <input [checked]="allSelected" type="checkbox" />
          <div class="option-content">Select all</div>
        </div>
      }
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
